import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { DatePipe } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe } from "@tolgee/ngx";
import { MaintenanceService } from "../../services/maintenance.service";

/**
 * Covers the whole app while the platform is in maintenance (`MaintenanceService.showScreen()`).
 * It leaves by itself: the `/status` probe reloads the page once the maintenance ends.
 * Above the CDK overlay container (z-index 1000), so that no dialog opened earlier shows through.
 * A supreme admin sets it aside from the browser console, `mitp.adminAccess()`, to reach the login.
 */
@Component({
	selector: "app-maintenance",
	templateUrl: "./maintenance.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DatePipe, MatIconModule, TranslatePipe],
})
export class MaintenanceComponent {
	maintenance = inject(MaintenanceService);
}
